import React, { useEffect } from 'react';
import styled from 'styled-components';
import Header from './components/Header';
import Footer from './components/Footer';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ExperiencePage from './pages/ExperiencePage';
import PortfolioPage from './pages/PortfolioPage';
import GalleryPage from './pages/GalleryPage';
import AboutPage from './pages/AboutPage';
import VideographerPage from './pages/VideographerPage';
import ContactPage from './pages/ContactPage';
import { LanguageProvider } from './contexts/LanguageContext';
import { useLanguage } from './contexts/LanguageContext';
import { HelmetProvider } from 'react-helmet-async';

const AppContainer = styled.div`
  min-height: 100vh;
  background: #fdfcfa;
  overflow-x: hidden; /* prevent accidental horizontal scroll on mobile */
`;

const LangSync = () => {
  const { pathname } = useLocation();
  const { setLang } = useLanguage();
  useEffect(() => {
    const isFr = pathname.startsWith('/fr');
    setLang(isFr ? 'fr' : 'en');
    try { document.documentElement.setAttribute('lang', isFr ? 'fr' : 'en'); } catch {}
  }, [pathname, setLang]);
  return null;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Always reset scroll to the very top on route change
    const scrollToTop = () => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      } catch (e) {
        window.scrollTo(0, 0);
      }
    };
    const id = setTimeout(scrollToTop, 0);
    return () => clearTimeout(id);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AppContainer>
          <LangSync />
          <ScrollToTop />
          <Header />
          <Routes>
            {/* EN routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/wedding-photographer" element={<ExperiencePage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/portfolio/:slug" element={<GalleryPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/wedding-videographer" element={<VideographerPage />} />
            <Route path="/contact" element={<ContactPage />} />

            {/* Legacy EN redirects */}
            <Route path="/experience" element={<Navigate replace to="/wedding-photographer" />} />
            <Route path="/videographer" element={<Navigate replace to="/wedding-videographer" />} />

            {/* FR routes */}
            <Route path="/fr" element={<HomePage />} />
            <Route path="/fr/photographe-mariage" element={<ExperiencePage />} />
            <Route path="/fr/portfolio" element={<PortfolioPage />} />
            <Route path="/fr/portfolio/:slug" element={<GalleryPage />} />
            <Route path="/fr/a-propos" element={<AboutPage />} />
            <Route path="/fr/videaste-mariage" element={<VideographerPage />} />
            <Route path="/fr/contact" element={<ContactPage />} />

            {/* Legacy FR redirects */}
            <Route path="/fr/experience" element={<Navigate replace to="/fr/photographe-mariage" />} />
            <Route path="/fr/about" element={<Navigate replace to="/fr/a-propos" />} />
            <Route path="/fr/videographer" element={<Navigate replace to="/fr/videaste-mariage" />} />
          </Routes>
          <Footer />
        </AppContainer>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
